import * as React from "react";
import MuiAppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Icon from "./Icon";
import { Tooltip, Button, Typography } from "@mui/material";
import { SettingsOutlined } from "@mui/icons-material";
import SettingsDialog from "./SettingsDialog";
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux";

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open, drawerwidth }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerwidth}px)`,
    marginLeft: `${drawerwidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default function DesktopAppBar({ drawerWidth, open, handleDrawerOpen }) {
  let navigate = useNavigate();
  const [settingsDialogOpen, setSettingsDialogOpen] = React.useState(false);
  const country = useSelector((state) => state.settings.country);
  

  const handleClickOpen = () => {
    setSettingsDialogOpen(true);
  };
  const handleClose = () => {
    setSettingsDialogOpen(false);
  };

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          background: "black",
        }}
        open={open}
        drawerwidth={drawerWidth}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            size="large"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(open && { display: "none" }) }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{
            m: 1
          }}>
            <Typography>
              Country: {country}
            </Typography>
          </Box>
          <Box sx={{ flexGrow: 1 }} />
          <Link
            to="/"
            style={{
              textDecoration: "none",
              color: "white",
            }}
          >
            <Icon />
          </Link>
          <Box sx={{ flexGrow: 1 }} />

          {/* <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <Button variant="outlined" startIcon={<SettingsOutlined />} onClick={handleClickOpen}>
                Settings
              </Button>
            </Tooltip>
          </Box>

          <SettingsDialog open={settingsDialogOpen} handleClose={handleClose} />
          <Box sx={{
            ml: 1
          }}>
            <Tooltip title="Open Admin Center">
              <Button
                variant="outlined"
                startIcon={<AdminPanelSettingsOutlinedIcon />}
                onClick={() => navigate("/admin-center/overview")}>
                Admin Center
              </Button>
            </Tooltip>
          </Box> */}
        </Toolbar>
      </AppBar>
    </>
  );
}
